import { Fragment, ReactNode, useState } from 'react';
import {
    Menu,
    Transition,
} from "@headlessui/react";
import { toast } from 'react-toastify';
import { DeleteCertificate } from '../../../api/Certificates/DeleteCertificate';
import DeleteModal from '../../Shared/DeleteModal';
import { ClipboardList, FileText, Pencil, PlusCircle, Trash2 } from 'lucide-react';
import {
    DashboardActionMenuPanel,
    DashboardMenuButton,
    DashboardMenuLink,
    dashboardActionMenuButtonClass,
} from '../Shared/DashboardActionMenu';

const CertificateDropdown = ({ children, certificateId }: { children?: ReactNode, certificateId: string; }) => {

    const [isMCQOpen, setIsMCQOpen] = useState(false);

    const handleDeleteCertificate = async (id: string) => {
        await DeleteCertificate(id);
        toast.success("Topic deleted successfully");
    };

    return (
        <div className="relative ">
            <Menu as="div" className="relative inline-block">
                <div>
                    <Menu.Button className={dashboardActionMenuButtonClass}>
                        {children}
                    </Menu.Button>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <DashboardActionMenuPanel>
                        <DashboardMenuLink icon={PlusCircle} to={`add-topic/${certificateId}`}>
                            Add Topic
                        </DashboardMenuLink>
                        <DashboardMenuLink icon={ClipboardList} to={`add-mockup/${certificateId}`}>
                            Add Mockup Exam
                        </DashboardMenuLink>
                        <DashboardMenuLink icon={Pencil} to={`edit-certificate/${certificateId}`}>
                            Edit Certificate
                        </DashboardMenuLink>
                        <DashboardMenuLink danger icon={Trash2} to={`delete-topic/${certificateId}`}>
                            Delete Topic
                        </DashboardMenuLink>
                        <DashboardMenuLink danger icon={FileText} to={`delete-mockups/${certificateId}`}>
                            Delete Mockups
                        </DashboardMenuLink>
                        <DashboardMenuButton danger icon={Trash2} onClick={() => setIsMCQOpen(true)}>
                            Delete Certificate
                        </DashboardMenuButton>
                    </DashboardActionMenuPanel>
                </Transition>
            </Menu>
            <DeleteModal
                isOpen={isMCQOpen}
                setIsOpen={setIsMCQOpen}
                mutationFn={() => handleDeleteCertificate(certificateId!)}
                itemId={certificateId!}
                queryKey="certificates"
            />
        </div>
    )
}

export default CertificateDropdown

